import { render } from "./TaskItemHeader.vue?vue&type=template&id=fb54f4a4&ts=true"
import script from "./TaskItemHeader.vue?vue&type=script&lang=ts"
export * from "./TaskItemHeader.vue?vue&type=script&lang=ts"

import "./TaskItemHeader.vue?vue&type=style&index=0&id=fb54f4a4&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__